import React from 'react';
import PropTypes from 'prop-types';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { BLACK } from '../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../theme/fontConstants';

import RequiredMark from './RequiredMark';

const HelperText = ({ helperKey }) => (
  <Typography
    sx={{ color: BLACK[60], fontFamily: PRIMARY_FONT[400], fontSize: '12px', marginTop: '6px' }}
  >
    {LanguageConverterV2(helperKey)}
  </Typography>
);

HelperText.propTypes = { helperKey: PropTypes.string.isRequired };

const FormFieldRow = ({ labelKey, helperKey, required = false, htmlFor, children }) => {
  const label = LanguageConverterV2(labelKey);

  return (
    <Box>
      <Typography
        component="label"
        htmlFor={htmlFor}
        sx={{
          color: BLACK[60],
          display: 'block',
          fontFamily: PRIMARY_FONT[700],
          fontSize: '11px',
          letterSpacing: '0.06em',
          marginBottom: '6px',
          textTransform: 'uppercase',
        }}
      >
        {label}
        {required && <RequiredMark />}
      </Typography>
      {children}
      {helperKey && <HelperText helperKey={helperKey} />}
    </Box>
  );
};

FormFieldRow.propTypes = {
  labelKey: PropTypes.string.isRequired,
  helperKey: PropTypes.string,
  required: PropTypes.bool,
  htmlFor: PropTypes.string,
  children: PropTypes.node,
};

export default FormFieldRow;
